import { Action, createReducer, on } from '@ngrx/store';

import * as HotSpotsActions from './hot-spots.actions';
import * as hotspotsFeatureState from './hot-spots.state';

const hotSpotsReducer = createReducer(
  hotspotsFeatureState.initialhotspotstate,

  on(HotSpotsActions.receivedLocationsListSuccess, (state, { data }) => {
    return {
      ...state,
      locations: data
    };
  }),
  on(HotSpotsActions.getHotSpotsSuccess, (state, { data }) => {
    const occupationHotSpots = data
      .filter((x) => !x.isHomeArea)
      .slice(0, 10) // show top 10
      .sort((a, b) => b.salary - a.salary);
    const occupationDemandInUserHomeArea = data.filter((x) => x.isHomeArea);

    return {
      ...state,
      occupationHotSpots,
      occupationDemandInUserHomeArea,
      occupationDemandbyArea: [
        ...occupationHotSpots,
        ...occupationDemandInUserHomeArea
      ]
    };
  })
);

export function reducer(
  state: hotspotsFeatureState.HotSpotsState | undefined,
  action: Action
) {
  return hotSpotsReducer(state, action);
}
